// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"8a4519e8","321":"bab342b7","682":"f1b9c275","888":"6b1e5773"}[chunkId] + ".chunk.js";
};